import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { NgxsModule } from "@ngxs/store";
import { CaseTypesState } from "@vp/data-access/case-types";
import { FlexModule } from "@vp/shared/directives/flex";
import { CaseTypeSelectorComponent } from "./case-type-selector/case-type-selector.component";
import { FormlyCaseTypeSelectorTypeComponent } from "./formly-case-type-selector-type/formly-case-type-selector-type.component";

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([CaseTypesState]),
    FlexModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    NgxsModule.forFeature([CaseTypesState])
  ],
  declarations: [CaseTypeSelectorComponent, FormlyCaseTypeSelectorTypeComponent],
  exports: [CaseTypeSelectorComponent, FormlyCaseTypeSelectorTypeComponent]
})
export class CaseTypeSelectorModule {}
